import { useRecoilValue } from "recoil";
import * as S from "./style";
import * as C from "../base/style";
import LiveList from "./component/live-list";
import { useEffect, useState } from "react";
import { pubState } from "../../../../../../recoil/pub.atom";
import { pushYoutubeList } from "../../../../../../api/youtube-live";
import { useTournamentContext } from "../../../../hook/context";
import { isTournamentAccess } from "../../../../../../utils/owner";

const LiveSetting = () => {
  const pub = useRecoilValue(pubState);
  const { allLiveList, setLiveList, isPush, setIsPush, tournamentId } =
    useTournamentContext();
  const [search, setSearch] = useState("");

  const handlePush = async () => {
    if (!pub || !tournamentId) return;
    if (isPush) {
      alert("이미 푸시메시지를 발송했습니다.");
      return;
    }

    if (!isTournamentAccess(+tournamentId, pub.tournamentIds)) {
      alert(`토너먼트 ID ${tournamentId}에 대한 권한이 없습니다. `);
      return;
    }

    const liveOnYoutuber = allLiveList
      .sort((a, b) => (a?.order || 0) - (b?.order || 0))
      .filter((item) => item.isLive === true)
      .map((item) => item.name)
      .join(", ");

    if (!liveOnYoutuber) return;

    const confirm = window.confirm(
      `전체 매장 회원에게 아래 내용으로 푸시가 발송됩니다. 발송 하시겠습니까? \n\n⭐️${liveOnYoutuber}⭐️ \nLIVE ON! 🃏 러너러너 앱에서 확인하세요! 🎥`,
    );
    if (!confirm) return;

    const request = {
      tournamentId,
      title: `⭐️${liveOnYoutuber}⭐️`,
      pubId: pub.id,
      description: `LIVE ON! 🃏 러너러너 앱에서 확인하세요! 🎥`,
    };
    try {
      await pushYoutubeList(request);
      alert("전송되었습니다. ");
      setIsPush(true);
    } catch (e: any) {
      console.error(e);
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
    }
  };

  const onSearch = () => {
    const filteredList = allLiveList.filter((item) =>
      item.name.toLowerCase().includes(search.toLowerCase()),
    );
    setLiveList(filteredList);
  };

  useEffect(() => {
    onSearch();
  }, [search]);

  return (
    <C.EditTournamentBaseWrapper>
      <C.EditTournamentBaseContent>
        <S.LiveSettingSearchWrapper>
          <S.LiveSettingSearch>
            <input
              type="text"
              placeholder="검색"
              value={search}
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  onSearch();
                }
              }}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
            <img
              onClick={onSearch}
              src="/image-web/timer-config/searchIcon.svg"
              alt="검색 아이콘"
            />
          </S.LiveSettingSearch>
          <div onClick={handlePush} className={`${isPush ? "" : "on"} button`}>
            PUSH 발송
          </div>
        </S.LiveSettingSearchWrapper>
        <S.LiveSettingHeaderInfo>
          ⚠️ 푸시메시지는 토너먼트당 1회만 발송가능합니다.
        </S.LiveSettingHeaderInfo>
      </C.EditTournamentBaseContent>
      <LiveList />
    </C.EditTournamentBaseWrapper>
  );
};

export default LiveSetting;
